import styled from 'styled-components'
import { useRef, useLayoutEffect, useState } from 'react'
import React from 'react'


const Contact = () => {
    const API_URL = process.env.REACT_APP_API_URL
    const headerRef = useRef(null)

    const [canSee, setCanSee] = useState(false)
    const classes = canSee ? 'header anime' : 'header'
    const contactClasses = canSee ? "contact-img view-contact-img" : "contact-img"
    const [person,setPerson] = useState({
        name: "",
        email: "",
        subject: "",
        message: ""
    })

    const handleChange = (e)=> {
        const name = e.target.name
        const value = e.target.value
        setPerson({...person, [name]:value})
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const data = new FormData()
        data.append("name", person.name)
        data.append("email", person.email)
        data.append("subject", person.subject)
        data.append("message", person.message)

        fetch(API_URL, {
            method: "POST",
            body: data
        }).then(()=> {
            alert("Message sent")
            setPerson({
                name: "",
                email: "",
                subject: "",
                message: ""
            })
        }).catch(e => console.log(e))
    }

    useLayoutEffect(() => {
        const onScroll = () => {
            const headerTop = headerRef.current.getBoundingClientRect().top
            const reached = headerTop < window.innerHeight
            setCanSee(reached)
        }

        
        window.addEventListener('scroll', onScroll)
        return () => {
            window.removeEventListener('scroll', onScroll)
        };
    })

    return (
        <Contents>
            <div id="contact" className="top-space"></div>
            <section>
                <header>
                    <h1
                    className={classes}
                    ref={headerRef}
                    >
                        Wanna Talk?
                    </h1>
                    <h2>
                        Add a contact form.
                    </h2>
                </header>
                <form
                onSubmit={handleSubmit}
                >
                    <div className="form-group">
                        <label htmlFor="">Your Name</label><br />
                        <input
                        type="text"
                        name="name"
                        id="name"
                        value={person.name}
                        onChange={handleChange}
                        className="form-control"
                        required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Your Email</label><br />
                        <input
                        type="email"
                        name="email"
                        id="email"
                        value={person.email}
                        onChange={handleChange}
                        className="form-control"
                        aria-describedby="emailHelp"
                        required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="">Subject</label><br />
                        <input
                        type="text"
                        name="subject"
                        id="subject"
                        value={person.subject}
                        onChange={handleChange}
                        className="form-control"
                        required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="message">Message</label><br />
                        <textarea
                        name="message"
                        id="message"
                        value={person.message}
                        onChange={handleChange}
                        rows="10"
                        className="form-control"
                        required
                        />
                    </div>
                    <div id="button">
                        <button
                        type="submit"
                        value="submit"
                        >Send</button>
                    </div>
                </form>
                <address>
                    <h3>Address</h3>
                    208, Indra Gandhi Street,<br />
                    Suthananthan Nagar,<br />
                    Palayapalayam,<br />
                    Erode, <br />
                    638011.
                </address>
                <div className="social-media">
                        <a target="_blank" rel="noreferrer" href="https://www.facebook.com/profile.php?id=100070448594548">
                            <div>
                                <i className="fab fa-facebook-f"></i>
                            </div>
                        </a>
                        <a target="_blank" rel="noreferrer" href="https://www.instagram.com/eroderoyal">
                            <div>
                                <i className="fab fa-instagram"></i>
                            </div>
                        </a>
                        <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/erode-royal-stainless-steels-516301217">
                            <div>
                                <i className="fab fa-linkedin-in"></i>
                            </div>
                        </a>
                        <a target="_blank" rel="noreferrer" href="tel:+918610118450">
                            <div>
                                <i className="fas fa-phone"></i>
                            </div>
                        </a>
                    </div>
            </section>
            <img
                className={contactClasses}
                src="/images/contact.png" alt="24/7 support"
                />
        </Contents>
    )
}

const Contents = styled.section`
    background: #000;
    color: #fff;
    position: relative;
    section {
        width: 90vw;
        margin: 0 auto;
    }
    header {
        margin: 2.5rem auto 0;
    }
    form {
        margin: 1rem auto 3rem;
    }
    .form-group,button {
        margin-top: 1rem;
    }
    label {
        line-height: 2rem;
    }
    h1 {
        color: #f9ea17;
        font-size: 2rem;
        transform: translateX(-40%);
        transition: transform 1s ease-in
    }
    input,textarea {
        width: 90%;
        border-radius: 0.5rem;
        resize: none;
    }
    input:focus, textarea:focus {
        border: 1px solid #f9ea17;
    }
    input {
        padding: 0.625rem;
        font-size: 1rem;
        font-weight: 500;
    }
    button {
        background: #f9ea17;
        border-radius: 50px;
        padding: 0.5rem 1.5rem;
        color: #121212;
        font-weight: 700;
        font-size: 1rem;
        animation: button 0.5s linear 0s infinite alternate;
    }
    #button {
        min-height: 80px;
    }
    .social-media a {
        display: inline-block;
        margin-left: 2rem;
        color: #fff;
        font-size: 1.2rem;
    }
    .social-media a:nth-child(1) {
        margin-left: 0;
    }
    @keyframes button {
        0% {
            transform: rotateZ(8deg);
        }
        40% {
            transform: rotateZ(-3deg);
        }
        60% {
            transform: rotateZ(0)
        }
        80% {
            transform: rotateZ(6deg);
        }
        100% {
            transform: rotateZ(-10deg);
        }
    }
    button:hover {
        background: #5c5c5c;
    }
    address {
        font-style: normal;
        padding-bottom: 3rem;
    }
    .anime {
        transform: translateX(0);
    }
    .contact-img {
        display: none;
    }
    @media screen and (min-width: 900px) {
        section {
            width: 60%;
            margin: 0 2rem;
        }
        .contact-img {
            display: block;
            position: absolute;
            width: 40%;
            height: 40%;
            right: 2.5%;
            top: 10%;
            opacity: 0;
            transition: opacity 2s ease-in;
        }
        .view-contact-img {
            opacity: 1; 
        }
    }
`;

export default React.memo(Contact)
